//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import StatusPassosItem from './StatusPassosItem';
import HistoricoTransferencia from './HistoricoTransferencia';
import { copyObject } from '../../common/functions/helpers';

export default {
  props: {
    entidade: String,
    source: {
      type: Object,
      default: {
        cabecalhoFluxo: null,
        passos: [],
      },
    },
  },
  data() {
    return {
      fluxoCopiado: {
        cabecalhoFluxo: null,
        passos: [],
      },
      dialog: false,
      passosTransferidos: {},
      colorPalette: [
        'teal accent-4', // Verde
        'red lighten-1', // Vermelho
        'orange darken-2', // Laranja
        'amber lighten-1', // Amarelo
        'blue-grey lighten-2', // Cinza
        'blue darken-1', // Azul
      ],
    };
  },
  components: {
    HistoricoTransferencia,
    StatusPassosItem,
  },
  watch: {
    source(val) {
      this.passosTransferidos = {};
      val.passos.filter(this.passoTemTransferencia)
        .forEach(this.convertePassoTransferico);
    },
  },
  computed: {
    titulo() {
      const tituloBase = this.$t('label.acompanhamento_fluxo');
      return this.source && this.source.cabecalhoFluxo ?
        `${tituloBase}  - ${this.source.cabecalhoFluxo.tipoFluxo}` :
        tituloBase;
    },
  },
  methods: {
    convertePassoTransferico(passo) {
      passo.usuarioTransferenciaPasso.forEach((u) => {
        const passoTrans = Object.assign({}, passo);
        passoTrans.statusPasso = 'TRANSFERIDO';
        passoTrans.usuarioTransferenciaPasso = u;
        this.preencherPassosTransferidos(passoTrans);
      });
    },
    preencherPassosTransferidos(passo) {
      if (this.passosTransferidos[passo.sequencia]) {
        this.passosTransferidos[passo.sequencia].push(passo);
      } else {
        this.passosTransferidos[passo.sequencia] = [passo];
      }
    },
    passoTemTransferencia(passo) {
      return passo.usuarioTransferenciaPasso && passo.usuarioTransferenciaPasso.length;
    },
    exibePasso(passo) {
      return passo.statusPasso !== 'CONDICAO_NAO_ATENDIDA' && passo.statusPasso !== 'TRANSFERIDO';
    },
    styles(status) {
      let colorIndex = 0;
      if (status === 'ENCERRADO') {
        colorIndex = 5;
      } else if (status === 'EM_CADASTRO') {
        colorIndex = 4;
      } else if (status === 'EM_FLUXO') {
        colorIndex = 4;
      } else if (status === 'CANCELADO') {
        colorIndex = 3;
      } else if (status === 'AGUARDANDO_APROVACAO') {
        colorIndex = 2;
      } else if (status === 'REPROVADO') {
        colorIndex = 1;
      } else if (status === 'AGUARDANDO_EXECUCAO_METAS') {
        colorIndex = 6;
      } else if (status === 'AGUARDANDO_APURACAO') {
        colorIndex = 5;
      } else if (status === 'AGUARDANDO_PAGAMENTO') {
        colorIndex = 5;
      } else if (status === 'APURACAO_PREVIA') {
        colorIndex = 4;
      } else if (status === 'EM_ANALISE') {
        colorIndex = 3;
      } else if (status === 'EM_REIVINDICACAO') {
        colorIndex = 2;
      } else {
        colorIndex = 0;
      }

      return this.color || this.colorPalette[colorIndex];
    },
    toDate(data) {
      return this.moment(data, 'DD/MM/YYYY hh:mm:ss').format('DD-MM-YYYY HH:mm:ss');
    },
    open() {
      this.dialog = true;
      setTimeout(() => {
        this.fluxoCopiado = copyObject(this.source);
        this.trataPassosRejeitados();
      });

      this.onOpen();
    },
    trataPassosRejeitados() {
      const { cabecalhoFluxo, passos } = this.fluxoCopiado;
      const { statusFluxo } = cabecalhoFluxo;
      if (statusFluxo !== 'REPROVADO' && statusFluxo !== 'EM_ANALISE') {
        return;
      }

      let indice = 0;
      while (indice < passos.length) {
        const passoLoop = passos[indice];
        const { statusPasso } = passoLoop;
        if (statusPasso === statusFluxo) {
          break;
        }
        indice += 1;
      }

      this.fluxoCopiado.passos = passos.slice(0, indice + 1);
    },
    defaultClose() {
      this.$emit('GENERICMODAL_DEFAULT_CLOSE');
      this.close();
    },
    onOpen() {
      this.$emit('GENERICMODAL_OPEN');
    },
    onClose() {
      this.$emit('GENERICMODAL_CLOSE');
    },
    close() {
      this.dialog = false;
      this.onClose();
    },
  },
};



// WEBPACK FOOTER //
// ./src/shared-components/workflow/StatusPassos.vue?vue&type=script&lang=js&